import React from 'react';
import Nav from '../MEP/SWNav';
import FooterSW from '../MEP/footer_SW';
import trans from '../../assets/Site_Web/pexels-johannes-strotker-2037694-4303917.jpg'

import ProjetsList from './composants_site_web/ProjetsList';


function Projets() {
  return (
    <div>
      <Nav/>
      <div className="containerSW" style={{marginLeft:'3%', marginRight:'3%'}}>
        <h1 className="propositionValeur titreSW">Dérisquer les transitions agroécologiques</h1>
        <div className='principal principal_strech'>
          <div className='bottom bottom2 bottom3' style={{marginTop:'0px'}} >
            <h2 className='sous-Titre-SW'>Nouvelles Pratiques, Impacts des bioagresseurs, dérisquons l’avenir ensemble.</h2>
            <div className='paragraphe paragrapheLanding'>DiagoRisk c'est : </div>
            <div className='row row2' style={{textAlign:'left', flexDirection:'column'}}>
              <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', width:'90%',  margin:'8px', border:'1px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)'}}>
                <h3 className='paragraphe paragrapheLanding' style={{fontWeight:'bold', marginBottom:'8px', marginTop:'5px'}}>
                  <span style={{color:'#92D050', fontSize:'16px', marginRight:'8px'}}>●</span>
                  Une plateforme de calcul des potentiels agricoles à 2050.
                </h3>
                <div className='paragraphe paragrapheLanding' style={{marginBottom:'8px'}}> Elle nous permet d’estimer l’évolution des rendements et leurs variabilités pour les vins et les grandes cultures</div>
              </div>
              <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', width:'90%',  margin:'8px', border:'1px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)'}}>
                <h3 className='paragraphe paragrapheLanding' style={{fontWeight:'bold', marginBottom:'8px', marginTop:'5px'}}>
                  <span style={{color:'#92D050', fontSize:'16px', marginRight:'8px'}}>●</span>
                  Un banc d’essai numérique pour mesurer l’efficacité des solutions et répondre à des questions :
                </h3>
                <div className='paragraphe paragrapheLanding' style={{marginBottom:'8px'}}>Sécuriser son activité à court et moyen termes</div>
                <ul className='paragraphe paragrapheLanding' style={{marginTop:'0px', paddingLeft:'16px'}}>
                  <li><div className='paragraphe paragrapheLanding lila'>Quelles variétés ? Quel assolement ?</div></li>
                  <li><div className='paragraphe paragrapheLanding lila'>Que ombrage pertinent pour mon installation agrivoltaïque ? </div></li>
                  <li><div className='paragraphe paragrapheLanding lila'>Quels seront les besoins en eau en 2035 ou 2050 ?</div></li>
                </ul>
              </div>
              <div style={{backgroundColor:'#FAFAFA', borderRadius:'10px', padding:'16px', width:'90%',  margin:'8px', border:'1px solid #818181', boxShadow:'0px 4px 10px rgba(0,0,0,0.1)'}}>
                <h3 className='paragraphe paragrapheLanding' style={{fontWeight:'bold', marginBottom:'8px', marginTop:'5px'}}>
                  <span style={{color:'#92D050', fontSize:'16px', marginRight:'8px'}}>●</span>
                  Un OAD pour mobiliser
                </h3>
              </div>
            </div>


            <div className='paragraphe paragrapheLanding' style={{width:'92%',backgroundColor:'#EDF8E1', padding:'20px 10px', borderLeft:'4px solid #75B532'}}>
              <span style={{fontWeight:'bold'}}>Une ambition commune :</span>
              <br />
              Dérisquer ces nouvelles pratiques pour accélérer leur adoption à grande échelle.
            </div>
          </div>
          
          <div className='top topBisBis'>
            <img src={trans} alt='Deux champs traversés par un chemin viscinal'  className='Mains2' style={{width:'100%'}}/>
          </div>
        </div>

        <h2 className='sous-Titre-SW' style={{marginBottom:'0px'}}>Nos projets</h2>
        <div className='paragraphe paragrapheLanding titre_centre' style={{marginTop:'5px'}}>Cliquez sur un projet pour en découvrir les détails, partenaires et enjeux. </div>
        
        <ProjetsList />
      </div>
      <FooterSW/>
    </div>
  );
}

export default Projets;

